import {
  CardContent,
  Grid,
  Box,
  Tooltip,
  IconButton,
  Divider,
} from '@mui/material';
import PageLoader from '../../../Components/Spinner/PageLoader';
import { ICompanyOwnerList } from '../../../rest/types';
import EditIcon from '@mui/icons-material/Edit';
import { useState } from 'react';
import UpdateCompanyOwner from '../../CompanyUpdateInfo/UpdateCompanyInformation/UpdateCompanyOwner';
import ModalsWrapper from '../../../Components/Modals/ModalsWrapper';
import PdfAndImageView from '../../../Components/pdfAndImageView/PdfAndImageView';
import { CommonTypoGraphy } from '../../../Components/pdfAndImageView/CommonTypoGraphy';
import CommonDetailItem, {
  formatValue,
} from '../../../Components/CommonDetailItem/CommonDetailItem';

type IProps = {
  data: ICompanyOwnerList[];
  loading: boolean;
  isApplied: number;
};

const CardCompanyOwner = ({ data, loading, isApplied }: IProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const [imageFile, setImageFile] = useState<string | null>('');
  const [toggle, setToggle] = useState(false);
  return (
    <>
      {!loading ? (
        data?.map((item: ICompanyOwnerList, index: number) => {
          return toggle ? (
            <Box key={index}>
              <UpdateCompanyOwner singleOwner={item} setToggle={setToggle} />
            </Box>
          ) : (
            <Box key={index}>
              <CardContent sx={{ position: 'relative' }}>
                <Grid container pt={1} spacing={2}>
                  <CommonDetailItem
                    label='Name'
                    value={
                      <>
                        {formatValue(item?.company_owner_name)}
                        {item?.company_representative ? (
                          <b style={{ marginLeft: 4 }}>(Will represent organization)</b>
                        ) : null}
                      </>
                    }
                  />
                  <CommonDetailItem
                    label='Designation'
                    value={formatValue(item?.company_owner_designation)}
                  />
                  <CommonDetailItem
                    label='Email'
                    value={formatValue(item?.company_owner_email)}
                  />
                  <CommonDetailItem
                    label='Address'
                    value={formatValue(item?.company_owner_address)}
                  />
                  <CommonDetailItem
                    label='Phone no'
                    value={formatValue(item?.company_owner_phone)}
                  />
                  <CommonDetailItem
                    label='Bio-data File'
                    value={
                      item?.company_owner_biodata ? (
                        <CommonTypoGraphy
                          name='View bio-data'
                          onClick={() => {
                            setOpen(true);
                            setImageFile(item.company_owner_biodata);
                          }}
                        />
                      ) : (
                        'N/A'
                      )
                    }
                  />
                  <CommonDetailItem
                    label='Photo'
                    value={
                      item?.company_owner_photo ? (
                        <CommonTypoGraphy
                          name='View photo'
                          onClick={() => {
                            setOpen(true);
                            setImageFile(item.company_owner_photo);
                          }}
                        />
                      ) : (
                        'N/A'
                      )
                    }
                  />
                  <CommonDetailItem
                    label='Passport'
                    value={
                      item?.company_owner_passport ? (
                        <CommonTypoGraphy
                          name='View Passport'
                          onClick={() => {
                            setOpen(true);
                            setImageFile(item.company_owner_passport);
                          }}
                        />
                      ) : (
                        'N/A'
                      )
                    }
                  />
                  <CommonDetailItem
                    label='Seal & Signature'
                    value={
                      item?.company_owner_signature ? (
                        <CommonTypoGraphy
                          name='View seal & signature'
                          onClick={() => {
                            setOpen(true);
                            setImageFile(item.company_owner_signature);
                          }}
                        />
                      ) : (
                        'N/A'
                      )
                    }
                  />
                  <CommonDetailItem
                    label='NID number'
                    value={formatValue(item?.company_owner_nid)}
                  />
                  <CommonDetailItem
                    label='NID file'
                    value={
                      item?.company_owner_nid_file ? (
                        <CommonTypoGraphy
                          name='View NID file'
                          onClick={() => {
                            setOpen(true);
                            setImageFile(item.company_owner_nid_file);
                          }}
                        />
                      ) : (
                        'N/A'
                      )
                    }
                  />
                  <CommonDetailItem
                    label='Resident'
                    value={formatValue(item?.country_name)}
                  />
                </Grid>

                {!isApplied && (
                  <Box sx={{ position: 'absolute', top: 0, right: 20 }}>
                    <Tooltip title='Update' sx={{ mr: 2 }}>
                      <IconButton onClick={() => setToggle(!toggle)}>
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>
                )}
                <Divider sx={{ mt: 3 }} />
              </CardContent>
            </Box>
          );
        })
      ) : (
        <PageLoader />
      )}
      <>
        <ModalsWrapper
          modalData={{ title: 'View document' }}
          setShowModal={setOpen}
          showModal={open}
        >
          <PdfAndImageView file={imageFile} />
        </ModalsWrapper>
      </>
    </>
  );
};

export default CardCompanyOwner;
